import moment from 'moment'

export default class ContactDomain {
	/**
	 * Handles the default constructor
	 * @param {string} contactPrimaryName - name
	 * @param {string} contactTitle - title
	 * @param {string} contactPhoneNumber - phone number
	 * @param {string} contactEmail - email address
	 * @param {number} id - id
	 * @param {number} phoneId - phone id
	 * @param {Array} contactTypes - array of contact type strings
	 * @param {number} priority - the sort priority for the contact type
	 * @param {boolean} vehicleRollingNotification - in create mode
	 * @param {boolean} dispatchedNotification - in create mode
	 * @param {boolean} isCreate - in create mode
	 * @param {boolean} isUpdate - in update mode
	 * @param {boolean} isDelete - in delete mode
	 * @param {boolean} readOnly - is this object readOnly
	 * @param {string} createdAt - created date
	 * @param {string} updatedAt - updated date
	 * @returns {ContactDomain} - returns the new ContactDomain object
	 */
	constructor(contactPrimaryName, contactTitle, contactPhoneNumber, contactEmail, id, phoneId, contactTypes, priority, vehicleRollingNotification, dispatchedNotification, readOnly, createdAt, updatedAt) {
		this.contactPrimaryName = contactPrimaryName
		this.contactTitle = contactTitle
		this.contactPhoneNumber = contactPhoneNumber
		this.contactEmail = contactEmail
		this.id = id
		this.phoneId = phoneId
		this.contactTypes = contactTypes || []
		this.priority = priority
		this.vehicleRollingNotification = vehicleRollingNotification || false
		this.dispatchedNotification = dispatchedNotification || false
		this.readOnly = readOnly
		this.isCreate = false
		this.isUpdate = false
		this.isDelete = false
		this.createdAt = moment(createdAt)
		this.updatedAt = moment(updatedAt)	}
}


// WEBPACK FOOTER //
// ./src/domains/ContactDomain.js